<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>样本管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体部分 -->
    <el-button type="primary" plain class="btn-add" @click="showEditSampleDialog">修改样本名</el-button>
    <el-card class="box-card">
    <el-tabs v-model="activeName" @tab-click="handleChangeTab" >
      <el-tab-pane label="微生物群落OTU表" name="otu_taxa_table.txt"></el-tab-pane>
      <el-tab-pane label="微生物属水平OTU表" name="genus.all.txt"></el-tab-pane>
      <el-tab-pane label="代谢组数据" name="all_sample_data.txt"></el-tab-pane>
      <el-tab-pane label="差异代谢物信息" name="DAMs.txt"></el-tab-pane>
    </el-tabs>
      <el-table :data="sampleData" max-height="800" ref="multipleTable" v-loading="loadingSample" border style="margin-top: 20px"
                tooltip-effect="dark" :fit="true " width="800px">
        <el-table-column v-for="name in sampleName" :key=name
                         :prop=name
                         :label=name.substring(4,name.length)
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column width="15px"></el-table-column>
      </el-table>
      <pagination :child-msg="samplePageChildMsg" @callFather="handlePagePagination"></pagination>
    </el-card>
    <el-dialog
      :destroy-on-close="true"
      title="更改样本信息"
      :visible.sync="editSampleDialogVisible"
      width="40%"

    >
      <el-form ref="sampleEditForm" label-width="7%" style="max-height:400px; overflow: auto">
        <el-form-item label="样本名" label-width="100px">
          <div v-for="(name,index ) in sampleNameCompare" :key=index v-if="!(index===0||index===sampleName.length-1)">
            <el-input id="setFont" type='text' style="width: 45% ;margin-bottom: 8px" :disabled="true"
                      :placeholder="name"></el-input>
            <img style="width: 25px;height: 10px;margin-left: 5px;margin-right: 5px" src="right.png"/>
            <el-input type='text' style=" width: 45%" v-model="sampleEditName[index]" :id="index"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
         <span slot="footer" class="dialog-footer">
           <el-button type="primary" @click="handleConfirmEdit" style="position: center">确 定</el-button>
           <el-button @click="closeEditSampleDialog" style="position: center">取 消</el-button>
      </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination'
import Upload from '@/components/Upload'
import QuitProject from '@/components/QuitProject'

const _ = require('lodash')
export default {
  data () {
    return {
      loadingSample: true,
      projectId: '',
      sampleData: [],
      sampleName: [],
      sampleEditName: [],
      sampleEditForm: [],
      activeName: 'otu_taxa_table.txt',
      value: [],
      fileName: '',
      deWeightIndex: '',
      repeat: '',
      firstElem: '',
      lastElem: '',
      samplePageChildMsg: {
        total: 0,
        pageSize: 8,
        currentNum: 1
      },
      sampleDataPageparm: {
        currentNum: 1,
        pageSize: 8
      },
      editSampleDialogVisible: false,
      sampleNameCompare: []

    }
  },
  components: {
    pagination: Pagination,
    'quit-project': QuitProject,
    upload: Upload
  },
  mounted () {
    this.getSamplePageData()
  },
  created: function () {
    this.projectId = this.$route.query.projectId
    const projectAll = this.$store.getters['right/getUser']
    if (!this.projectId && projectAll && projectAll.projectsRow) {
      this.projectId = projectAll.projectsRow.projectId
    }
  },
  methods: {
    checkRepeat (arr) {
      const arrStr = JSON.parse(JSON.stringify(arr))
      for (let i = 0; i < arr.length; i++) {
        if (arrStr.indexOf(arr[i]) !== arrStr.lastIndexOf(arr[i])) {
          this.deWeightIndex = i
          return true
        }
      }
      return false
    },
    findall (a, x) {
      const results = []
      const len = a.length
      let pos = 0
      while (pos < len) {
        pos = a.indexOf(x, pos)
        if (pos === -1) {
          break
        }
        results.push(pos)
        pos += 1
      }
      return results
    },
    findElements (arr, elems) {
      var returnIndex = []
      for (var i = 0; i < arr.length; i++) {
        elems.map(item => {
          if (arr[i] === item) {
            returnIndex.push(i + 1)
          }
        })
      }
      return returnIndex
    },
    handlePagePagination (pageparm) {
      this.sampleDataPageparm = pageparm
      this.getSamplePageData()
    },
    // }
    async getSamplePageData (type) {
      if (type) {
        this.sampleDataPageparm.currentNum = 1
      }
      const sendData = {
        pageNum: this.sampleDataPageparm.currentNum,
        pageSize: this.sampleDataPageparm.pageSize,
        projectId: this.projectId,
        fileName:this.activeName
      }
      this.loadingSample = true
      const res = await this.$http.post('/sample/all', sendData)
      if (res) {
        if (res.code == 200) {
          this.loadingSample = false
          const pageData = res.data
          this.sampleData = pageData.data
          // this.sampleData = res.data.data; // 将处理后的数据赋值给 this.sampleData
          this.samplePageChildMsg.total = pageData.totalNum
          this.samplePageChildMsg.pageSize = pageData.pageSize
          this.samplePageChildMsg.currentNum = pageData.currentNum
          this.sampleName = pageData.data[0]
          this.sampleName = Object.keys(this.sampleName).sort() // 按照字母顺序排序
        }
      }
    },
    updataData () {
      const divide = Math.floor(this.samplePageChildMsg.total / this.sampleDataPageparm.pageSize)
      if (divide + 1 === this.sampleDataPageparm.currentNum &&
        this.samplePageChildMsg.total % this.sampleDataPageparm.pageSize === 1) {
        if (this.sampleDataPageparm.currentNum > 1) {
          this.sampleDataPageparm.currentNum--
        }
      }
    },
    async showEditSampleDialog () {
      const res = await this.$http.get('/sample/nameCompare/' + this.projectId)
      if (res) {
        if (res.code !== 200) {
          alert('发生错误，请稍后再试')
          return
        }
      } else {
        alert('发生错误，请稍后再试')
        return
      }
      const sampleName = this.sampleName
      this.sampleNameCompare = sampleName.map(item => {
        item = item.substring(4, item.length)
        if (item in res.data) {
          if (item !== res.data[item] && res.data[item] !== '') {
            return item + '（' + res.data[item] + '）'
          }
          return item
        } else {
          return item
        }
      })
      const firstIndex = this.sampleName[0]
      const a = this.sampleName.indexOf(firstIndex)
      this.sampleEditName = sampleName.map(item => {
        return item.substring(4, item.length)
      })
      // this.sampleEditName = JSON.parse(JSON.stringify(this.sampleName))
      this.editSampleDialogVisible = true
    },
    async closeEditSampleDialog () {
      await this.getSamplePageData()
      this.editSampleDialogVisible = false
    },
    async handleConfirmEdit () {
      var cleanArr = []
      for (var i = 1; i < this.sampleEditName.length - 1; i++) {
        cleanArr.push(i)
      }
      cleanArr.forEach(function (item) {
        const showTag = document.getElementById(item)
        showTag.style.backgroundColor = ''
      })
      this.sampleEditName = this.sampleEditName.map(item => item.trim())
      const flag = this.checkRepeat(this.sampleEditName)
      if (flag) {
        const mes = this.sampleEditName[this.deWeightIndex]
        const indexArr = this.findall(this.sampleEditName, mes)
        this.$messageUi.error('样本名有重复，请检查数据' + mes)
        indexArr.forEach(function (item) {
          const showTag = document.getElementById(item)
          showTag.style.backgroundColor = '#F08080'
        })
      } else {
        var sampleArr = JSON.parse(JSON.stringify(this.sampleEditName))
        sampleArr.shift()
        var spaceInSample = []
        sampleArr.map(item => {
          if (item.includes(' ')) {
            spaceInSample.push(item)
          }
        })
        var indexArr = this.findElements(sampleArr, spaceInSample)
        indexArr.forEach(function (item) {
          const showTag = document.getElementById(item)
          showTag.style.backgroundColor = '#F08080'
        })
        if (spaceInSample.length > 0) {
          this.$messageUi.error('样本名之间不能有空格，请检查' + spaceInSample)
        } else {
          await this.confirmEdit()
        }
      }
    },
    async confirmEdit () {
      const sendData = new FormData()
      // console.log( this.sampleEditName)
      sendData.set('projectId', this.projectId)
      sendData.set('sampleName', this.sampleEditName)
      const res = await this.$http.post('sample/edit', sendData)
      if (res) {
        if (res.code === 200) {
          this.closeEditSampleDialog()
          await this.updataData()
          await this.getSamplePageData()
          this.$messageUi.success('修改成功')
        } else {
          this.$messageUi.error(res.message)
        }
      }
    },
    handleChangeTab (tab, event) {
      this.activeName = tab.name
      this.getSamplePageData('changeTab')
    }
  }
}

</script>

<style lang="scss" scoped>

.btn-add {
  margin: 20px;
}

.el-breadcrumb {
  line-height: 40px;
}
</style>
